var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector724(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 30,
    viewBox: "0 0 17 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91192 1.75488C7.91192 7.22306 7.91192 12.6912 7.91192 18.1594C7.91192 19.1627 8.29191 25.9968 7.55357 25.4061C6.29596 24.4 5.15889 22.6531 3.97005 21.4642C-0.305917 17.1883 4.63688 25.7917 5.76181 27.1978C7.87808 29.8432 14.2191 17.522 15.079 16.0889",
    stroke: "#2F2F37",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector724);
export default __webpack_public_path__ + "static/media/Vector724.47833915d51de1ea3f3695e25ead13c3.svg";
export { ForwardRef as ReactComponent };